import type { AxiosInstance } from 'axios';
import type {
  Task,
  TaskListQueryParams,
  TaskListResponse,
  EntityId,
} from '@/types';

export const getTasks = async (
  api: AxiosInstance,
  limit = 50,
  start_key: string | undefined = undefined,
  status: string | undefined = undefined,
  name: string | undefined = undefined,
): Promise<TaskListResponse> => {
  const resp = await api.get<TaskListResponse>('/task', {
    params: { limit, start_key, status, name } as TaskListQueryParams,
  });
  return resp.data;
};

export const getTask = async (
  api: AxiosInstance,
  task_id: EntityId,
): Promise<Task> => {
  const resp = await api.get<Task>(`/task/${task_id}`);
  return resp.data;
};

